import axios from 'axios'
import { attachAuthInterceptor } from 'kach-clients'

const WITH_AUTH_INTERCEPTOR: boolean = true

axios.defaults.withCredentials = true

const instance = axios.create({
  withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_KACH_API_BASE_URL,
})

const httpClient = WITH_AUTH_INTERCEPTOR
  ? attachAuthInterceptor(instance)
  : instance

export default httpClient
